import {format} from "date-fns";

export class DateFormatter {
  static formatDate(date: Date | undefined) {
    if (!date) return "";

    return format(new Date(date), "yyyy-MM-dd");
  }

  static formatDateTime(date: Date) {
    return format(new Date(date), "MM/dd/yyyy HH:mm:ss");
  }
}
